<div class="disable-text-select">
  @if (isNativeApp) {
    <div class="native-app-top-bar"></div>
  }
  @if (isDotLive) {
    <ng-container>
      @if (isPwa) {
        <div
          role="alert"
          class="alert alert-warning m-0 fade show text-center small"
        >
          <div class="mb-3">
            This version of Guard Tracker will be discontinued soon,
            <span class="fw-semibold"
              >please uninstall and/or remove this app from your device.</span
            >
          </div>
          <div>
            To continue using Guard Tracker, sign in at
            <a
              class="terms-link pointer"
              href="https://app.guardtracker.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              >https://app.guardtracker.com.au/</a
            >
          </div>
        </div>
      }
      @if (!isPwa) {
        <div
          role="alert"
          class="alert alert-warning m-0 fade show text-center small"
        >
          <div class="mb-3">
            This version of Guard Tracker will be discontinued soon.
          </div>
          <div>
            To continue using Guard Tracker, sign in at
            <a
              class="terms-link pointer"
              href="https://app.guardtracker.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              >https://app.guardtracker.com.au/</a
            >
          </div>
        </div>
      }
    </ng-container>
  }

  <ng-container>
    @if ((successMessage && !successTick) || (errorMessage && !failureCross)) {
      <div [ngStyle]="messageStyle">
        <!-- Success Message -->
        @if (successMessage && !successTick) {
          <div
            (click)="clearAlert()"
            role="alert"
            class="alert alert-success m-0 fade show"
          >
            {{ successMessage }}
          </div>
        }
        <!-- Error Message -->
        @if (errorMessage && !failureCross) {
          <div
            (click)="clearAlert()"
            role="alert"
            class="alert alert-warning m-0 fade show"
          >
            {{ errorMessage }}
          </div>
        }
      </div>
    }
    @if (successTick) {
      <div class="gt-response-animation-container">
        <div
          class="success-animation"
          [ngStyle]="successTick == 'isNativeApp' ? { top: '80%' } : {}"
        >
          <svg
            class="checkmark"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
          >
            <circle
              class="checkmark__circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              class="checkmark__check"
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
          <div class="text-light position-relative pt-2">
            {{ successMessage }}
          </div>
        </div>
      </div>
    }
    @if (failureCross) {
      <div class="gt-response-animation-container">
        <div
          class="failure-animation"
          [ngStyle]="failureCross == 'isNativeApp' ? { top: '80%' } : {}"
        >
          <svg
            class="crossmark"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
          >
            <circle
              class="crossmark__circle"
              cx="26"
              cy="26"
              r="25"
              fill="#f44336"
            />
            <path
              class="crossmark__cross"
              fill="none"
              d="M15 15L37 37M15 37L37 15"
            />
          </svg>
          <div class="text-light position-relative pt-2 text-center">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    }

    <router-outlet></router-outlet>
    @if (showSpinner) {
      <div class="d-flex justify-content-center gt-loader-container">
        <div class="spinner-border text-white gt-loader" role="status"></div>
        <div class="text-light custom-loading-text">{{ spinnerMessage }}</div>
        @if (hideSpinnerManualOption) {
          <button
            (click)="
              showSpinner = false; hideSpinnerManualOption = false; pageReload()
            "
            class="btn btn-md btn-primary close-button"
          >
            Close
          </button>
        }
      </div>
    }
  </ng-container>
</div>
